// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { LoadingWow } from './loading-wow';

export function LoadingPage(): Node {
  return (
    <LoadingRoot>
      <LoadingWow />
    </LoadingRoot>
  );
}

const LoadingRoot = styled.div`
  display: flex;
  align-items: center;
  min-height: 100vh;
  justify-content: center;
  background: #dfe3e8;
`;

export default LoadingPage;
